const WEEKDAYS = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];
const ORDINALS = ["First", "Second", "Third", "Fourth", "Fifth"];

export function getWeekOfMonth(date: Date): number {
  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  return Math.ceil((date.getDate() + firstDay.getDay()) / 7);
}

export function getOrdinal(n: number): string {
  return ORDINALS[n - 1] ?? `${n}th`;
}

export function getDaySuffix(n: number): string {
  if (n >= 11 && n <= 13) return "th";
  return ["th", "st", "nd", "rd"][Math.min(n % 10, 4)] || "th";
}